// Module
var code = "You should now return to location you chose as the bridge or waterfront..<br> Press ‘I’m there’ when you are.";
// Exports
module.exports = code;